<template>
    <div id="choiceVipCard">
        <div id="headers">
            <img src="../assets/images/img_31.png" alt="" @click="returnPage" id="returns">
            <div class="headerText">兑换视频会员页</div>
            <div class="rule" @click="inExchangeVideoVipByLaws">细则</div>
        </div>
        <!-- banner -->
        <div class="banners">
            <div class="bannerBox">该视频平台热播剧banner</div>
        </div>
        <!-- 选择卡 -->
        <div class="chooseCard">
            <div class="bdShadow" @click="inExchangeVipCard(150)"><img src="../assets/images/img_64.png" alt=""></div>
            <div class="bdShadow" @click="inExchangeVipCard(42)"><img src="../assets/images/img_65.png" alt=""></div>
            <div class="bdShadow" @click="inExchangeVipCard(15)"><img src="../assets/images/img_67.png" alt=""></div>
            <div class="bdShadow" @click="inExchangeVipCard(8)"><img src="../assets/images/img_68.png" alt=""></div>
        </div>
    </div>
</template>

<script>
    export default {
        components:{
            
        },
        data() {
            return {
                
            }
        },
        methods: {
            returnPage:function(){
                this.$router.go(-1);
            },
            // 进入 兑换视频会员细则
            inExchangeVideoVipByLaws:function(){
                this.$router.push('/exchangeVideoVip/exchangeVideoVipByLaws');
            },
            // 进入 确认兑换会员卡
            inExchangeVipCard:function(priceNum){
                // this.$router.push({name:'exchangeVipCard',params: {price: priceNum}});
                this.$router.push({name:'exchangeVipCard',query: {price: priceNum}});
            }
        },
    }
</script>

<style lang="less" scoped>
    #choiceVipCard{
        // 导航栏
        #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            #returns{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
            .rule{
                font-size:15px;
                color:rgba(255,255,255,1);
                position: absolute;
                right: 25px;
            }
        }
        // banner
        .banners{
            width:375px;
            height:75px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            padding-top: 15px;
            .bannerBox{
                width:345px;
                height:100px;
                background:linear-gradient(26deg,rgba(98,107,106,1) 0%,rgba(215,222,229,1) 100%);
                border-radius:5px;
                font-size:25px;
                font-family:Arial, Helvetica, sans-serif;
                color:rgba(255,255,255,1);
                line-height:100px;
                text-align: center;
                text-shadow:0px 1px 1px rgba(0,0,0,0.1);
                margin: 0 15px;
                box-shadow: 0 5px 10px rgba(0,0,0,0.1);
            }
        }
        // 选择卡
        .chooseCard{
            margin-top: 40px;
            padding: 0 15px;
            .bdShadow{
                width:345px;
                height:68px;
                outline-width:0px;
                vertical-align:top;
                margin-bottom: 18px;
                box-shadow:0px 4px 7px 0px rgba(230,230,230,1);
                img{
                    width: 100%;
                    height: 100%;
                    pointer-events:none;
                }
            }
        }
    }
</style>